import Model from 'flarum/common/Model';

export default class CaseAiReport extends Model {}

Object.assign(CaseAiReport.prototype, {
  caseId: Model.attribute('case_id'),
  tokenCost: Model.attribute('token_cost'),
  starCost: Model.attribute('star_cost'),
  reportContent: Model.attribute('report_content'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  case: Model.hasOne('case'),
});
